import { isArray, isEmpty, isPlainObject } from 'lodash';
import querystring from 'query-string';

class URLBuilderService {
  constructor() {
    this.headerFields = [];
  }

  separateParamsWithHeaderFields(rootUrl) {
    const { url, query } = querystring.parseUrl(rootUrl || '');
    let webhookURL = url;

    const paramsUrl = [];
    const headerFieldsByValues = this.headerFields.map((el) => el.value);
    const queryNotInHeaderFields = {};

    if (isPlainObject(query) && !isEmpty(query)) {
      Object.entries(query).forEach(([param, value]) => {
        if (headerFieldsByValues.includes(value)) {
          paramsUrl.push({ param, value });
        } else {
          queryNotInHeaderFields[param] = value;
        }
      });
    }

    if (!isEmpty(queryNotInHeaderFields)) {
      const newParams = new URLSearchParams();
      Object.entries(queryNotInHeaderFields).forEach(([param, value]) => {
        newParams.set(param, value);
      });

      webhookURL = `${webhookURL}?${newParams.toString()}`;
    }

    return { paramsUrl, url: webhookURL };
  }

  concatURL(rootUrl = '', params = []) {
    const urlParser = new URLSearchParams();
    const haveRootUrlHaveQuestionMark = rootUrl?.includes('?');
    const sign = haveRootUrlHaveQuestionMark ? '&' : '?';

    if (isArray(params)) {
      params
        .filter((el) => !!el.param && !!el.value)
        .forEach((el) => {
          urlParser.set(el.param, el.value);
        });
    }
    return `${rootUrl}${sign}${urlParser.toString()}`;
  }
}

export default new URLBuilderService();
